import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function KitOrderCreateMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.kit.order.create(0));
  };

  return (
    <MainMenuItem
      itemTitleString="キットを発注する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default KitOrderCreateMenuItem;
